/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React from 'react';
import {
  oneOfType,
  arrayOf,
  string,
  func,
  bool,
  shape,
} from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import Small from './Small';
import Icon from './Icon';

import './RadioControl.scss';

class RadioControl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: null,
    };

    this.onOptionClickWithOption = this.onOptionClickWithOption.bind(this);
  }

  static getDerivedStateFromProps({ value }, { selectedValue: prevValue }) {
    if ((_.isNull(value) || _.isUndefined(value)) || value === prevValue) return null;

    return {
      selectedValue: value,
    };
  }

  onOptionClickWithOption(option) {
    const { onChange } = this.props;
    const { value } = option;
    this.setState({
      selectedValue: value,
    });

    if (onChange) onChange(option);
  }

  render() {
    const {
      idPrefix,
      options,
      disabled,
      title,
      error,
      isClean,
      validationText,
      isShowValidationIcon,
      inline,
      dataSelectorId,
    } = this.props;
    const { selectedValue } = this.state;

    const classes = {
      'radio-control': true,
      error,
      inline,
    };

    return (
      <div className={classNames(classes)}>
        {title && (
          <label className="radio-title-wrapper">
            <strong>{title}</strong>
          </label>
        )}
        <div className="radios">
          {options.map((option, index) => {
            const { value, label } = option;
            const radioClasses = {
              radio: true,
              selected: selectedValue === value,
              disabled,
            };
            return (
              <div
                // eslint-disable-next-line
                key={index}
                className={classNames(radioClasses)}
                onClick={() => !disabled && this.onOptionClickWithOption(option)}
              >
                <div className="radio-input-box">
                  <input
                    type="radio"
                    id={`${idPrefix}-${index}`}
                    disabled={disabled}
                    className="radio-input"
                    name={`${idPrefix}-${index}`}
                    value={value}
                    checked={selectedValue === value}
                    readOnly
                    data-selector={`${dataSelectorId}-${value}`}
                  />
                  <label htmlFor={`${idPrefix}-${index}`}>
                    <strong>{label || value}</strong>
                  </label>
                </div>
              </div>
            );
          })}
        </div>
        {validationText && !isClean && (
          <div className="radio-validation-wrapper">
            {isShowValidationIcon && (
              <span className="radio-validation-icon">
                <Icon name="info" />
              </span>
            )}
            <Small>{validationText}</Small>
          </div>
        )}
      </div>
    );
  }
}

RadioControl.defaultProps = {
  options: [],
  value: null,
  onChange: undefined,
  disabled: false,
  error: false,
  isClean: false,
  title: '',
  validationText: null,
  isShowValidationIcon: true,
  inline: false,
  dataSelectorId: '',
};

RadioControl.propTypes = {
  idPrefix: string.isRequired,
  options: arrayOf(
    shape({
      value: oneOfType([string, bool]).isRequired,
      label: string,
      disabled: bool,
    })
  ),
  value: oneOfType([string, bool]),
  onChange: func,
  disabled: bool,
  error: bool,
  isClean: bool,
  title: string,
  validationText: string,
  isShowValidationIcon: bool,
  inline: bool,
  dataSelectorId: string,
};

export default RadioControl;
